import { Injectable } from '@angular/core';
import { BaseWidgetService } from '../base-widget.service';

import { applicantDashboardService } from 'common/services/data-services/admin/applicants-dashboard/applicant-dashboard.service';
import {
  MetaModel,
} from 'common/models/utility-models/base-model';
import { environment } from 'src/environments/environment';

import { API_URL, FORM_STEP_OPTIONS } from 'common/constants/sm-constants';
import { SystemService } from 'common/services/core-services/system.service';
import { StudentTotalListDataService } from '../../services/data-services/admin/applicants-dashboard/student-list.service';
import { applicantDashboardModel } from 'common/models/page-models/applicants/applicant-dashboard/applicant-dashboard-data.model';
import { applicantDashboardMetaModel } from 'common/models/page-models/applicants/applicant-dashboard/applicant-dashboard-form-meta.model';
import { ApplicantCountStorageService } from 'common/services/data-services/admin/applicants-dashboard/applicant-count.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Injectable({
  providedIn: 'root',
})
export class applicantdashboardWidgetService extends BaseWidgetService<applicantDashboardModel> {
  constructor(
    public ds: applicantDashboardService,
    protected ss: SystemService,
    private sl: StudentTotalListDataService, private storageService: ApplicantCountStorageService,        protected modalService: NgbModal,
    
  ) {
    super(ds);
  }

  getMetaModel(): MetaModel {
    const meta = new applicantDashboardMetaModel();
    return meta.getMetaModel();
  }

  override prepareMetaModel(
    dataModel: applicantDashboardModel,
    metaModel: applicantDashboardMetaModel,
    routeData: any
  ): Promise<applicantDashboardMetaModel> {
    return new Promise<applicantDashboardMetaModel>((resolve, reject) => {
      // console.log(dataModel,'widget service')
      //   const studentDetails=
      //   {
      //     statusFlag:Number(dataModel.statusFlag),
      //     region_search:'',
      //     state_search:'',
      //     gender_search:'',
      //     department_search:''
      //   }

      // const lastUpdatedPayload = this.storageService.getLastAddedRowStatus();

      // if (lastUpdatedPayload !== null) {
      //   const selectedOption = FORM_STEP_OPTIONS.find(
      //     (option) => option.name === lastUpdatedPayload
      //   );

      //   if (selectedOption) {
      //     studentDetails.statusFlag = Number(selectedOption.id);
      //   }
      // }


      //   this.sl.postData(studentDetails).then((data) => {
      //     dataModel.studentList = data.details;
      //   });
      metaModel.properties.selectedState.options = dataModel.formstateList
      resolve(metaModel);
    });
  }

  // override getUrlList() {
  //   let postobj = {
  //     statusFlag: 0,
  //   };

  //   const lastUpdatedPayload = this.storageService.getLastAddedRowStatus()
  //   const selectedOption = FORM_STEP_OPTIONS.find(
  //     (option) => option.name === lastUpdatedPayload
  //   );

  //   if(lastUpdatedPayload !== null)
  //   {
  //     console.log('hello');

  //     postobj.statusFlag === Number(selectedOption.id)
  //   }
  //   console.log(postobj,lastUpdatedPayload,'apiCallFromMultipleAPIforGrid');


  //   const urlList = [
  //     {
  //       url: environment.apiUrl + API_URL.getapplicantDashboard,
  //       payload: postobj,
  //     },
  //     { url: environment.apiUrl + API_URL.stateList, payload: '' },
  //   ];

  //   return urlList;
  // }

  override getUrlList() {
    let postobj = {
      statusFlag: 0,
    };

    const lastUpdatedPayload = this.storageService.getLastAddedRowStatus();

    // Check if we got a valid status from getLastAddedRowStatus
    if (lastUpdatedPayload !== null) {
      const selectedOption = FORM_STEP_OPTIONS.find(
        (option) => option.name === lastUpdatedPayload
      );

      // If we found a matching option, update the statusFlag
      if (selectedOption) {
        // console.log('hello');

        postobj.statusFlag = Number(selectedOption.id);  // Corrected assignment
      }
    }

    // console.log(postobj, lastUpdatedPayload, 'apiCallFromMultipleAPIforGrid');

    const urlList = [
      {
        url: environment.apiUrl + API_URL.getapplicantDashboard,
        payload: postobj,
      },
      { url: environment.apiUrl + API_URL.stateList, payload: '' },
    ];

    return urlList;
  }


  deleteApplicants() {
    this.ds
      .postDataToCustomEndPoint(
        null,
        null,
        environment.apiUrl + API_URL.deleteApplicant
      )
      .then((data: any) => {
        this.ss.showSuccess(data.msg);
        this.modalService.dismissAll()
        location.reload();
      });
  }


  startRegistration(body) {
    this.ds
      .postDataToCustomEndPoint(
        body,
        null,
        environment.apiUrl + API_URL.startRegistration
      )
      .then((data) => {
        this.ss.showSuccess(data['msg']);
      });
  }
}
